import { PagedResultDto } from "@services/dto/pagedResultDto"
import { L, LNotification } from "@lib/abpUtility"
import { notifyError, notifySuccess } from "@lib/helper"
import http from "@services/httpService"

class AccountingDocumentTypeService {
  public async getAll(params: any): Promise<PagedResultDto<any>> {
    const res = await http.get(
      "api/services/app/AccountingDocumentType/GetAll",
      {
        params,
      }
    )
    return res.data.result
  }
  public async get(id: number): Promise<any> {
    if (!id) {
      notifyError(L("ERROR"), L("ENTITY_NOT_FOUND"))
    }
    const res = await http.get("api/services/app/AccountingDocumentType/Get", {
      params: { id },
    })
    const { result } = res.data
    return result
  }

  public async createOrUpdate(body: any) {
    const res = await http.post(
      "api/services/app/AccountingDocumentType/CreateOrUpdate",
      body
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("SAVING_SUCCESSFULLY")
    )
    return res.data.result
  }
  public async activate(id: number, isActive) {
    const res = await http.post(
      "api/services/app/AccountingDocumentType/Active",
      { id },
      { params: { isActive } }
    )
    notifySuccess(
      LNotification("SUCCESS"),
      LNotification("UPDATE_SUCCESSFULLY")
    )
    return res.data
  }
  public async getList(): Promise<any> {
    const res = await http.get(
      "api/services/app/AccountingDocumentType/GetList"
    )
    const { result } = res.data
    return result
  }
  public async getListForAdmin(): Promise<any> {
    const res = await http.get(
      "api/services/app/AccountingDocumentType/GetListForAdmin"
    )
    const { result } = res.data
    return result
  }
}

export default new AccountingDocumentTypeService()
